/**
 * Canonical physical deployment prefix. Always `/` or a single-slash-prefixed
 * path with one trailing slash.
 */
export function documentBase(): string {
  const raw = import.meta.env.BASE_URL || "/";
  const path = `/${raw.replace(/^\/+|\/+$/g, "")}`;
  return path === "/" ? "/" : `${path}/`;
}

/**
 * Router base excludes the deployment suffix slash except at the origin root.
 */
export function routerBase(): string {
  const base = documentBase();
  return base === "/" ? "/" : base.slice(0, -1);
}

/**
 * Convert a document or router path to the canonical router-logical domain.
 */
export function normalizeRouterPath(pathname: string): string {
  const base = routerBase();
  const withoutBase =
    base !== "/" && (pathname === base || pathname.startsWith(`${base}/`))
      ? pathname.slice(base.length)
      : pathname;
  const suffix = withoutBase.replace(/^\/+/, "").replace(/\/{2,}/g, "/");
  return suffix ? `/${suffix}` : "/";
}

/**
 * Convert a browser pathname to a canonical router-logical path.
 */
export function toRouterPath(browserPathname: string): string {
  return normalizeRouterPath(browserPathname);
}

/**
 * Convert a router-logical path to a physical deployment URL.
 */
export function deploymentHref(routerPath: string): string {
  const path = normalizeRouterPath(routerPath);
  const base = documentBase();
  return path === "/" ? base : `${base.slice(0, -1)}${path}`;
}
